/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../_themeBase/_helpers";



export const SportReservActionsColumnFormatter = (
    cellContent,
    row,
    rowIndex,
    { openSportReservDialog }
) => (
    <>
        <OverlayTrigger
            overlay={<Tooltip id="objects-edit-tooltip">رزرو سانس</Tooltip>}
        >
            <a
                className="btn btn-icon btn-light btn-hover-success btn-sm mx-3"
                onClick={() => openSportReservDialog(row.id)}
            >
                <span className="svg-icon svg-icon-md svg-icon-success">
                    <SVG
                        src={toAbsoluteUrl("/media/svg/icons/Devices/Server.svg")}
                    />
                </span>
            </a>
        </OverlayTrigger>
    </>
);
